import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import partial from "lodash/partial";
import ConfirmDialog from "common/components/modal/confirmation_dialog";
import { toggleRemoveDraft, removeDraft } from "your_projects/ducks";

const mapStateToProps = ({ yourProjects: { removingDraft } }) => {
  return {
    dialogVisible: !!removingDraft,
    dialogHeader: removingDraft
      ? `Are you sure you want to delete ${
          removingDraft.title || "this project"
        }?`
      : "",
    dialogMessage: "This action cannot be undone.",
    primaryActionText: "Yes, delete",
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      toggleDialog: partial(toggleRemoveDraft, null),
      submitAction: removeDraft,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDialog);
